const angular = require('angular')
const date = require('./date')
const size = require('./size')
const email = require('./email')
const html = require('./html')
const attachment = require('./attachment')
const py = require('./py')
const misc = require('./misc')
const pop = require('./popUp')
const progressbar = require('./progressbar')
const notify = require('./notify')
const recursionHelper = require('./recursionHelper')
const uiHelper = require('./uiHelper')
const pinyin = require('./pinyin')
const qr = require('./qr')
const detector = require('./detector')
const loadSync = require('./loadSync')
const modalFunc = require('./modalFunc')
const crypt = require('./crypt')

/* Services */
module.exports = angular.module('hxphone.utils', [])
/* 以下服务仅供$utils依赖或工具之间的相互依赖，不建议在utils模块外部单独使用 */
  .provider('$$date', date)
  .provider('$$size', size)
  .provider('$$email', email)
  .provider('$$html', html)
  .provider('$$attachment', attachment)
  .provider('$$py', py)
  .provider('$$misc', misc)
  .provider('$$pop', pop)
  .provider('$$progressbar', progressbar)
  .provider('$$notify', notify)
  .factory('recursionHelper', recursionHelper)
  .provider('$$uiHelper', uiHelper)
  .provider('$pinyin', pinyin)
  .provider('$$qr', qr)
  .provider('$$detector', detector)
  .provider('$$loadSync', loadSync)
  .provider('$$modalFunc', modalFunc)
  .provider('$$crypt', crypt)

/* 工具服务 */
  .service('$utils', ['$$date', '$$size', '$$email', '$$html', '$$attachment', '$$py', '$$misc', '$$pop', '$$progressbar',
    '$$notify', 'recursionHelper', '$$uiHelper', '$pinyin', '$$qr', '$$detector', '$$loadSync', '$$modalFunc', '$$crypt',
    function ($$date, $$size, $$email, $$html, $$attachment, $$py, $$misc, $$pop, $$progressbar, $$notify, recursionHelper, $$uiHelper, $pinyin, $qr, $detector, $$loadSync, $$modalFunc, $$crypt) {
      return {
        $date: $$date,
        $size: $$size,
        $email: $$email,
        $html: $$html,
        $attachment: $$attachment,
        $py: $$py,
        $misc: $$misc,
        $pop: $$pop,
        $progressbar: $$progressbar,
        $notify: $$notify,
        recursionHelper: recursionHelper,
        $uiHelper: $$uiHelper,
        $pinyin: $pinyin,
        $qr: $qr,
        $detector: $detector,
        $loadSync: $$loadSync,
        $modalFunc: $$modalFunc,
        $crypt: $$crypt,
      }
    }
  ])

// 扩展$rootScope的$off方法以释放多个在$rootScope上注册的事件
  .run(['$rootScope', function ($rootScope) {
    // Custom $off function to un-register the listener.
    $rootScope.$off = function (name, listener) {
      if (angular.isDefined(listener)) {
        const namedListeners = this.$$listeners[name]
        if (namedListeners) {
          // Loop through the array of named listeners and remove them from the array.
          for (let i = 0; i < namedListeners.length; i++) {
            if (namedListeners[i] === listener) {
              return namedListeners.splice(i, 1)
            }
          }
        }
      } else {
        const eventNames = name.split(' ')
        for (let j = 0; j < eventNames.length; j++) {
          this.$$listeners[eventNames[j]] = []
        }
      }
    }
  }])



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/module.js